import { Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, ManyToOne, JoinColumn } from 'typeorm';
import { ApparelArticleMaster } from './apparel-article-master.entity';

@Entity('measurement_chart_2t')
export class MeasurementChart2T {
    @PrimaryGeneratedColumn()
    id: number;

    @Column({ name: 'pom_name', type: 'varchar', length: 255 })
    pomName: string;

    @Column({ name: 'description', type: 'varchar', length: 255 })
    description: string;

    @Column({ name: 'pom_variation', type: 'varchar', length: 255 })
    pomVariation: string;

    @Column({ name: 'qc', type: 'varchar', length: 50 })
    qc: string;

    @Column({ name: 'tol_fraction_minus', type: 'varchar', length: 50 })
    tolFractionMinus: string;

    @Column({ name: 'tol_fraction_plus', type: 'varchar', length: 50 })
    tolFractionPlus: string;

    @Column({ name: 'tolerance_message', type: 'varchar', length: 255 })
    toleranceMessage: string;

    @Column({ name: 'grading_override_message', type: 'varchar', length: 255 })
    gradingOverrideMessage: string;

    @Column({ name: 'size_2t', type: 'varchar', length: 50 })
    size2T: string;

    @Column({ name: 'size_3t', type: 'varchar', length: 50 })
    size3T: string;

    @Column({ name: 'size_4t', type: 'varchar', length: 50 })
    size4T: string;

    @Column({ name: 'size_5t', type: 'varchar', length: 50 })
    size5T: string;


    @ManyToOne(() => ApparelArticleMaster, (am) => am.measurementChart2t)
    @JoinColumn({ name: 'apparel_article_id' })
    apparelArticleId: ApparelArticleMaster

    @CreateDateColumn({
        name: "created_at",
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user",
    })
    createdUser: string | null;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user",
    })
    updatedUser: string | null;

    @CreateDateColumn({
        name: "updated_at",
    })
    updatedAt: string;
}
